import { render, staticRenderFns } from "./ProvinceAccordion.vue?vue&type=template&id=281fe429&scoped=true"
import script from "./ProvinceAccordion.vue?vue&type=script&lang=js"
export * from "./ProvinceAccordion.vue?vue&type=script&lang=js"
import style0 from "./ProvinceAccordion.vue?vue&type=style&index=0&id=281fe429&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281fe429",
  null
  
)

export default component.exports